import React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function ThumbUp24() {
  return /*#__PURE__*/_jsxs("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M8.90722 20.9999H18.0881C18.4826 20.9996 18.8678 20.8947 19.1934 20.6991C19.519 20.5034 19.7699 20.2261 19.9132 19.9033L22.9606 13.557C23.0536 13.3471 23.1007 13.1238 23.0996 12.8986V11.0892C23.0996 10.1005 22.1922 8.9988 21.0807 8.9988H16.0027C15.3515 8.9988 14.874 8.38632 15.0329 7.75481L15.681 5.17908L15.7133 4.89795C15.7131 4.54216 15.5541 4.20061 15.2703 3.9467L14.8555 3.58248C14.4765 3.24972 13.9091 3.25121 13.5319 3.58596L7.46629 8.96891C7.08782 9.30802 6.87683 9.76447 6.87908 10.2393V19.2377C6.87983 19.4705 6.93296 19.7009 7.03541 19.9157C7.13787 20.1304 7.28762 20.3252 7.47608 20.489C7.66455 20.6527 7.88799 20.7822 8.13359 20.8698C8.37919 20.9575 8.6421 21.0017 8.90722 20.9999Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M0.899653 11.5012C0.899653 10.9489 1.34737 10.5012 1.89965 10.5012H3.31738C3.86967 10.5012 4.31738 10.9489 4.31738 11.5012V20C4.31738 20.5523 3.86967 21 3.31738 21H1.89965C1.34737 21 0.899653 20.5523 0.899653 20V11.5012Z",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinejoin: "round"
    })]
  });
}